import React, { useState, useEffect } from "react";
import { Container, Button, Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import "../../Styles/yellocalfcss/CollectRegistrationFee.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

const CollectRegistrationFee = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [filters, setFilters] = useState({
    invoiceId: "",
    student: "",
    rfid: "",
    email: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [invoices, setInvoices] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const invoicesPerPage = 15;

  useEffect(() => {
    fetchFailedCollectFee();
  }, []);

  const fetchFailedCollectFee = async () => {
    setIsLoading(true);
    
    // You can use these if the API requires dynamic data
    // const user_id = localStorage.getItem("user_id");
    // const api_key = localStorage.getItem("api_key");

    try {
      // 1. Fixed Payload Syntax
      const payload = {
        customer_id: 1005,
        api_key: "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: 14857,
        status: "registrationfeecollection",
        action: "",
        student_name: "",
        ref_id: "",
        grade: "",
        email: ""
      };

      const response = await simplePostCall(
        ApiConfig.collectRegistrationFee,
        JSON.stringify(payload)
      );

      if (response?.searchModel) {
        // 2. Map API Response to Table Structure
        // Note: The API response provided is for Students, but the table expects Invoice Data.
        // I have mapped the available fields and put placeholders for missing financial data.
        const fetchedData = response.searchModel.map((item) => ({
          id: item.student_registration_id, // Used for Invoice ID column
          rfid: item.student_registration_rfid || "N/A",
          student: `${item.student_registration_first_name} ${item.student_registration_last_name}`,
          grade: item.student_registration_class,
          demandDate: formatDate(item.student_registration_application_date),
          dueDate: "-", // Not provided in API response
          amountTotal: "0.00", // Not provided in API response
          amountPaid: "0.00", // Not provided in API response
          balance: "0.00", // Not provided in API response
          fee_invoice_id: item.student_registration_id // Used for navigation
        }));

        setInvoices(fetchedData);
      } else {
        setMessage(response?.message || "No results found");
        setInvoices([]);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      setMessage("Error fetching details");
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to format dates
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return dateString.split("T")[0];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setFilters({ invoiceId: "", student: "", rfid: "", email: "" });
  };

  // Filter logic
  const filteredInvoices = invoices.filter((invoice) => {
    return (
      (filters.invoiceId === "" ||
        String(invoice.id).toLowerCase().includes(filters.invoiceId.toLowerCase())) &&
      (filters.student === "" ||
        String(invoice.student).toLowerCase().includes(filters.student.toLowerCase()))
    );
  });

  // Pagination Logic
  const indexOfLastInvoice = currentPage * invoicesPerPage;
  const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;
  const currentInvoices = filteredInvoices.slice(indexOfFirstInvoice, indexOfLastInvoice);

  return (
    <div className="verification-main-wrapper my-4">
      <Container fluid className="verification-container-fluid">
        <div className="verification-header-section">
          <h1 className="verification-title-text">Verified Enquiries</h1>
        </div>
        
        {/* Filters Section */}
        <div
          className="d-flex align-items-center gap-2 mb-2"
          style={{ marginTop: "10px" }}
        >
          <div style={{ position: "relative" }}>
            <FaSearch
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
                fontSize: "14px",
              }}
            />
            <Form.Control
              type="text"
              placeholder="ID Search"
              name="invoiceId"
              value={filters.invoiceId}
              onChange={handleChange}
              style={{
                width: "180px",
                height: "36px",
                paddingLeft: "30px",
              }}
            />
          </div>

          <div style={{ position: "relative" }}>
            <FaSearch
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
                fontSize: "14px",
              }}
            />
            <Form.Control
              type="text"
              placeholder="Filter by Student"
              name="student"
              value={filters.student}
              onChange={handleChange}
              style={{
                width: "180px",
                height: "36px",
                paddingLeft: "30px",
              }}
            />
          </div>

          <Button
            onClick={handleClear}
            className="verification-export-btn custom-btn"
            style={{ height: "38px", width: "85px" }}
          >
            Clear
          </Button>
          
          <Button
            onClick={fetchFailedCollectFee}
            className="btn btn-primary"
            style={{ height: "38px", marginLeft: "10px" }}
          >
            Search
          </Button>
        </div>

        {message && (
          <div className="verification-message-display alert alert-info mt-2">{message}</div>
        )}

        {/* Table Header */}
        <div className="verification-table-header-row mt-3">
          <div className="verification-grid-layout">
            <div className="verification-header-cell">Sr No</div>
            <div className="verification-header-cell">ID</div>
            <div className="verification-header-cell">First Name</div>
            <div className="verification-header-cell">Grade</div>
            <div className="verification-header-cell">App Date</div>
            <div className="verification-header-cell">Due Date</div>
            <div className="verification-header-cell">Amount</div>
            <div className="verification-header-cell">Paid</div>
            <div className="verification-header-cell">Balance</div>
            <div className="verification-header-cell verification-actions-header">
              <span
                className="verification-actions-text"
                style={{ marginLeft: "23px" }}
              >
                Actions
              </span>
            </div>
          </div>
        </div>

        {/* Table Body */}
        {isLoading ? (
         <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "10vh" }} //here loader height defined
          >
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : (
        <div className="verification-data-rows-container">
          {isLoading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : currentInvoices.length > 0 ? (
            currentInvoices.map((invoice, index) => (
              <div key={index} className="verification-single-row-card">
                <div className="verification-grid-layout">
                  <div className="verification-data-cell">
                    {(currentPage - 1) * invoicesPerPage + index + 1}
                  </div>
                  <div className="verification-data-cell" style={{ fontSize: "13px" }}>
                    {invoice.id}
                  </div>
                  <div className="verification-data-cell" style={{ fontSize: "13px" }}>
                    {invoice.student}
                  </div>
                  <div className="verification-data-cell" style={{ fontSize: "13px" }}>
                    {invoice.grade}
                  </div>
                  <div className="verification-data-cell" style={{ fontSize: "13px" }}>
                    {invoice.demandDate}
                  </div>
                  <div className="verification-data-cell" style={{ fontSize: "13px" }}>
                    {invoice.dueDate}
                  </div>
                  <div className="verification-data-cell" style={{ fontSize: "13px" }}>
                    {invoice.amountTotal === "0.00" ? "-" : `$${invoice.amountTotal}`}
                  </div>
                  <div className="verification-data-cell" style={{ fontSize: "13px" }}>
                    {invoice.amountPaid === "0.00" ? "-" : `$${invoice.amountPaid}`}
                  </div>
                  <div className="verification-data-cell" style={{ fontSize: "13px" }}>
                    {invoice.balance === "0.00" ? "-" : `$${invoice.balance}`}
                  </div>
                  <div className="verification-data-cell verification-action-buttons-container" style={{ fontSize: "10px", gap: "1px", marginLeft: "10px" }}>
                    <button className="verification-action-icon-btn" onClick={() => navigate(`/CustomerViewInvoice/${invoice.fee_invoice_id}`)}>
                      <FaEye />
                    </button>

                    <button
                      className="verification-action-icon-btn"
                      title="Send Invoice"
                      // onClick={() => navigate("/SendInvoice")}
                      onClick={() => navigate(`/SendInvoice/${invoice.fee_invoice_id}`)}
                    >
                      <FaEdit />
                    </button>

                    <button
                      className="verification-action-icon-btn"
                      title="Delete Invoice"
                      onClick={() => setMessage(`Delete Invoice ID: ${invoice.id}`)}
                    >
                      <FaTrashAlt />
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-5">No Records Found</div>
          )}
        </div>
        
        )}
        <div className="pending-invoices-pagination-text">
          Showing {currentInvoices.length > 0 ? indexOfFirstInvoice + 1 : 0} - {Math.min(indexOfLastInvoice, filteredInvoices.length)} of {filteredInvoices.length} items
        </div>
      </Container>
    </div>
  );
};

export default CollectRegistrationFee;